import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";

class OrganizationAPI extends BaseAPI {
    constructor() {
        super();
    }

    apiName = "TaskGo";
    controllerName = "OrganizationUnits";

    /**
     * Lấy dữ liệu danh sách tree
     * CreateBy:NTCONG:03.11.2021
     */
    getOrganizationLevel2(payload) {
        let request = {
            url: this.getAPIUrl() + "/organization-level2",
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
     * Lấy form đơn vị mới
     * VDGiang 11/10/2022
     */
    getNewOrganization(payload) {
        let request = {
            url: this.getAPIUrl() + "/new",
        };

        return httpClient.getAsync(request);
    }

    /**
     * Xóa 1 đơn vị
     * @param {*} payload 
     * @returns 
     */
    delete(payload) {
        let request = {
            url: this.getAPIUrl(),
            data: payload
        };
        return httpClient.putAsync(request);
    }

    /**
     * Lấy tổng số đơn vị
     * @param {*} payload 
     * @returns 
     */
    getTotalOrganizationUnit(payload) {
        let request = {
            url: this.getAPIUrl() + "/list-summary",
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
     * cập thứ tự xắp xếp cây đơn vị
     * @param {*} payload 
     * @returns 
     * CreateBy:NTCONG:16.11.2021
     */
    updateSortOrder(payload) {
        let request = {
            url: this.getAPIUrl() + "/updatesortorder",
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
     * load tree theo cơ cấu cha con
     * @param {param} payload 
     * @returns 
     * CreateBy:NTCONG:22.11.2021
     */
    getListTreeByParent(payload) {
        let request = {
            url: this.getAPIUrl() + "/list/",
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
     * Lấy paging cây đơn vị
     * @param {} payload 
     * @returns 
     */
    getPagingTree(payload) {
        let request = {
            url: this.getAPIUrl() + "/paging/",
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
     * load tree theo cơ cấu cha con
     * @param {param} payload 
     * @returns 
     * CreateBy:NTCONG:22.11.2021
     */
    getListTree(payload) {
        let request = {
            url: this.getAPIUrl() + "/list",
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
     * Lưu thông tin đơn vị
     * @param {*} payload 
     * @returns 
     */
    updateTenantInfor(payload) {
        let request = {
            url: this.getAPIUrl() + "/updateTenantInfor",
            data: payload
        };

        return httpClient.putAsync(request);
    }

    /**
     * cập thứ tự xắp xếp cây đơn vị
     * @param {*} payload 
     * @returns 
     * CreateBy:NTCONG:21.11.2021
     */
    async validateDelete(payload) {
        let request = {
            url: this.getAPIUrl() + "/validateDelete",
            data: payload
        };

        return await httpClient.postAsync(request);
    }

    /**
     * Them/Sua/Xoa nhieu
     * @param {*} payload 
     * @returns 
     * CreateBy: LMDuc:11.10.2022
     */
    async multiSubmit(payload) {
        let request = {
            url: this.getAPIUrl() + "/submit",
            data: payload
        };

        return await httpClient.postAsync(request, true);
    }
}

export default new OrganizationAPI();